var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "topbar" }, [
      _c("i", { on: { click: _vm.goHome1 } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox1" }, [
        _c(
          "div",
          {
            staticClass: "changeLangBtn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.moreLang()
              }
            }
          },
          [
            _vm._v(
              "\r\n            " +
                _vm._s(_vm.$t("language")) +
                "\r\n            "
            ),
            _c("em", { staticClass: "iconfont icon-een" }),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeLangBox,
                    expression: "changeLangBox"
                  }
                ],
                staticClass: "chooseLangUl"
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "chooseLangUlli",
                    on: {
                      click: function($event) {
                        _vm.setLanguage(item.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "changeLangBtn1",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.goLogin()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("homepage_button1")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "forget" }, [
        _c("div", { staticClass: "forgetPsd" }, [
          _vm._v(_vm._s(_vm.$t("verifyFail_title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm._v(_vm._s(_vm.$t("verifyFail_txt")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-290b1831", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290b1831","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invalidLink.vue
// module id = null
// module chunks = 